module.exports = __webpack_public_path__ + "static/booth-f8e5e32d68e5099e6b3969fab9148cfa.webp";